/* OIF Collection — minimal client-side behavior.
   - Rotates Baghdad Bob's quotes and exposes dot navigation.
   - Keeps legacy tag filter links light; Empire handles the collection URL.
   - Reveals "show more" filter values.
   No framework. Re-runs on Shopify section reloads via section.load. */

(function () {
  function initBob(root) {
    var quotes = root.querySelectorAll('[data-oif-bob-q]');
    var attrs  = root.querySelectorAll('[data-oif-bob-attr]');
    var dots   = root.querySelectorAll('[data-oif-bob-dot]');
    var num    = root.querySelector('[data-oif-bob-num]');
    if (!quotes.length) return;
    var i = 0;

    function show(n) {
      i = (n + quotes.length) % quotes.length;
      quotes.forEach(function (el, k) { el.hidden = k !== i; });
      attrs.forEach(function (el, k) { el.hidden = k !== i; });
      dots.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
      if (num) num.textContent = String(i + 1).padStart(2, '0');
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-oif-bob-dot'), 10));
        clearInterval(t);
        t = setInterval(tick, 7000);
      });
    });

    function tick() { show(i + 1); }
    var t = setInterval(tick, 7000);
  }

function initCanForm(root) {
    // Older versions used checkbox inputs. Keep this harmless fallback for any
    // legacy rows that still render as inputs.
    root.querySelectorAll('.rip__row input[type=checkbox]').forEach(function (input) {
      input.addEventListener('change', function () {
        var label = input.closest('.rip__row');
        if (label) label.classList.toggle('is-on', input.checked);
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
    // hide-more reveal
    root.querySelectorAll('[data-oif-show-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.parentElement;
        body.classList.add('is-expanded');
        btn.style.display = 'none';
        body.querySelectorAll('.rip__row[hidden]').forEach(function (r) { r.hidden = false; });
      });
    });
  }

  function initEmpireFilters(root) {
    var wrap = root.querySelector('.rip__facets--empire');
    if (!wrap) return;

    var mode = wrap.getAttribute('data-oif-filter-groups') || 'expand_all';

    wrap.querySelectorAll('[data-productgrid-sidebar-group]').forEach(function (group, index) {
      var trigger = group.querySelector('[data-filter-group-trigger]');
      var content = group.querySelector('[data-accordion-content]');
      if (!trigger || !content) return;

      var hasActive = !!group.querySelector('[data-filter-active="true"], [aria-current="true"]');
      var shouldOpen = mode === 'expand_all' || (mode === 'expand_first' && index === 0) || hasActive;

      function setOpen(open) {
        trigger.classList.toggle('productgrid--sidebar-button-active', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.setAttribute('data-accordion-state', open ? 'open' : 'closed');
      }

      setOpen(shouldOpen);
      if (trigger.dataset.oifEmpireFilterReady === '1') return;
      trigger.dataset.oifEmpireFilterReady = '1';
      trigger.addEventListener('click', function () {
        setOpen(trigger.getAttribute('aria-expanded') !== 'true');
      });
    });

    wrap.querySelectorAll('[data-filter-toggle]').forEach(function (toggle) {
      if (toggle.dataset.oifEmpireToggleReady === '1') return;
      toggle.dataset.oifEmpireToggleReady = '1';
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var expanded = toggle.getAttribute('data-filter-toggle') === 'true';
        var parent = toggle.parentElement && toggle.parentElement.parentElement;
        if (!parent) return;
        parent.querySelectorAll('[data-hidden-default]').forEach(function (item) {
          item.classList.toggle('filter-item--hidden', expanded);
        });
        toggle.setAttribute('data-filter-toggle', expanded ? 'false' : 'true');
        toggle.textContent = expanded ? 'See more' : 'See less';
      });
    });
  }

  function restoreCollapsedState(host) {
    // Restore desktop-collapsed state from localStorage on page load.
    var stored;
    try { stored = localStorage.getItem('oif-can-collapsed'); } catch (e) { stored = null; }
    if (stored === '1' && window.matchMedia('(min-width: 901px)').matches) {
      host.classList.add('is-collapsed');
      var trigger = host.querySelector('[data-oif-mobile-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }

  function initMobileDrawer(host) {
    var trigger  = host.querySelector('[data-oif-mobile-trigger]');
    var closeBtns = host.querySelectorAll('[data-oif-mobile-close]');
    var backdrop = host.querySelector('[data-oif-backdrop]');
    if (!trigger && !closeBtns.length && !backdrop) return;
    var lockedScrollY = 0;

    function isMobile() {
      return window.matchMedia('(max-width: 900px)').matches;
    }

    function lockPageScroll() {
      if (document.body.classList.contains('oif-can-open')) return;
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('oif-can-open');
      document.body.classList.add('oif-can-open');
    }

    function unlockPageScroll() {
      if (!document.body.classList.contains('oif-can-open')) return;
      document.documentElement.classList.remove('oif-can-open');
      document.body.classList.remove('oif-can-open');
      window.scrollTo(0, lockedScrollY);
    }

    function open() {
      if (isMobile()) {
        host.classList.add('is-mobile-open');
        lockPageScroll();
      } else {
        host.classList.remove('is-collapsed');
        try { localStorage.setItem('oif-can-collapsed', '0'); } catch (e) {}
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      var hadMobileLock = host.classList.contains('is-mobile-open') || document.body.classList.contains('oif-can-open');
      if (hadMobileLock) {
        host.classList.remove('is-mobile-open');
        unlockPageScroll();
      }
      if (!isMobile()) {
        host.classList.add('is-collapsed');
        try { localStorage.setItem('oif-can-collapsed', '1'); } catch (e) {}
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    function toggle() {
      var openNow = isMobile()
        ? host.classList.contains('is-mobile-open')
        : !host.classList.contains('is-collapsed');
      if (openNow) close(); else open();
    }

    function containDrawerTouch(event) {
      if (!host.classList.contains('is-mobile-open') || !isMobile()) return;
      if (event.target.closest('[data-oif-can]')) return;
      event.preventDefault();
    }

    if (trigger)  trigger.addEventListener('click', toggle);
    closeBtns.forEach(function (closeBtn) {
      closeBtn.addEventListener('click', close);
    });
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('touchmove', containDrawerTouch, { passive: false });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && host.classList.contains('is-mobile-open')) close();
    });

    window.addEventListener('resize', function () {
      if (!isMobile() && host.classList.contains('is-mobile-open')) close();
    });

    // Close drawer after a filter row is checked on mobile (so the user sees results)
    host.querySelectorAll('.rip__row input[type=checkbox]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (host.classList.contains('is-mobile-open')) close();
      });
    });
  }

  function initSortSelect(host) {
    var select = host.querySelector('[data-oif-sort-select]');
    if (!select || select.dataset.oifSortReady === '1') return;
    select.dataset.oifSortReady = '1';
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  }

  function initViewToggle(host) {
    var grid = host.querySelector('[data-oif-grid]');
    var buttons = host.querySelectorAll('[data-oif-view-button]');
    if (!grid || !buttons.length) return;

    function setView(view) {
      var list = view === 'list';
      grid.classList.toggle('is-list-view', list);
      buttons.forEach(function (button) {
        var active = button.getAttribute('data-oif-view') === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    var stored = 'grid';
    try { stored = localStorage.getItem('oif-deck-view') || 'grid'; } catch (e) {}
    setView(stored === 'list' ? 'list' : 'grid');

    buttons.forEach(function (button) {
      if (button.dataset.oifViewReady === '1') return;
      button.dataset.oifViewReady = '1';
      button.addEventListener('click', function () {
        var view = button.getAttribute('data-oif-view') || 'grid';
        setView(view);
        try { localStorage.setItem('oif-deck-view', view); } catch (e) {}
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-oif-bob]').forEach(initBob);
    document.querySelectorAll('[data-oif-can]').forEach(function (can) {
      initCanForm(can);
      initEmpireFilters(can);
    });
    document.querySelectorAll('.v6-host').forEach(function (host) {
      restoreCollapsedState(host);
      initMobileDrawer(host);
      initSortSelect(host);
      initViewToggle(host);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: re-init on section load
  document.addEventListener('shopify:section:load', initAll);
})();
